import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight, Film, X } from 'lucide-react';

function isVideoItem(item) {
  const mt = (item?.media_type || item?.mime_type || '').toLowerCase();
  return mt.includes('video') || /\.(mp4|mov|webm|m4v)(\?|$)/i.test(item?.path || item?.url || '');
}

function storyThumbRingClass(storyFit) {
  if (storyFit === 'bad') {
    return 'ring-2 ring-red-500';
  }
  if (storyFit === 'warn') {
    return 'ring-2 ring-amber-500';
  }
  if (storyFit === 'good') {
    return 'ring-2 ring-green-500';
  }
  return 'ring-1 ring-gray-300 dark:ring-white/25';
}

export default function GymSocialStoryMediaStrip({
  media,
  selectedIndex,
  onSelect,
  onRemove,
  onMove,
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap gap-2">
      {media.map((item, index) => (
        <div key={`${item.path}-${index}`} className="flex flex-col items-center gap-1">
          <div className="relative">
            <button
              type="button"
              onClick={() => onSelect(index)}
              className={`block rounded-lg overflow-hidden ${storyThumbRingClass(item.storyFit)} ${
                selectedIndex === index ? 'outline outline-2 outline-offset-2 outline-indigo-500' : ''
              }`}
              aria-label={t('gym.social.posts.storySelectSlide', { n: index + 1 })}
            >
              {isVideoItem(item) ? (
                <div className="relative h-20 w-14 bg-black flex items-center justify-center">
                  <Film className="h-6 w-6 text-white/90" />
                </div>
              ) : (
                <img src={item.url} alt="" className="h-20 w-14 object-cover" />
              )}
              <span className="absolute bottom-0 left-0 right-0 text-center text-[10px] font-medium bg-black/60 text-white py-0.5">
                {index + 1}
              </span>
            </button>
            <button
              type="button"
              onClick={() => onRemove(index)}
              className="absolute -top-1 -right-1 p-0.5 rounded-full bg-red-600 text-white shadow opacity-90 hover:opacity-100"
              aria-label={t('gym.social.posts.removeImage')}
            >
              <X className="h-3 w-3" />
            </button>
          </div>
          {media.length > 1 && (
            <div className="flex gap-0.5">
              <button
                type="button"
                disabled={index === 0}
                onClick={() => onMove(index, -1)}
                className="p-1 rounded border border-gray-300 dark:border-white/20 disabled:opacity-30 hover:bg-gray-100 dark:hover:bg-white/10"
                aria-label={t('gym.social.posts.moveImageEarlier')}
              >
                <ChevronLeft className="h-3 w-3" />
              </button>
              <button
                type="button"
                disabled={index === media.length - 1}
                onClick={() => onMove(index, 1)}
                className="p-1 rounded border border-gray-300 dark:border-white/20 disabled:opacity-30 hover:bg-gray-100 dark:hover:bg-white/10"
                aria-label={t('gym.social.posts.moveImageLater')}
              >
                <ChevronRight className="h-3 w-3" />
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
